export const useMusicToMvUpsellFlag = () => {
  const config = useRuntimeConfig();

  return computed(() => config.public.enableMusicToMvUpsell === true);
};
